import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { ACCESS_TOKEN } from "../../constatns";

class OAuth2RedirectHandler extends Component {
	getUrlParameter(name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');

		var results = regex.exec(this.props.location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	};

	render() {
		const token = this.getUrlParameter('accessToken');
		const id = this.getUrlParameter('id');
		const email = this.getUrlParameter('email');
		const error = this.getUrlParameter('error');

		if(token) {
			localStorage.setItem(ACCESS_TOKEN, token);
			localStorage.setItem("__ID__", id);
			localStorage.setItem("__EM__", email);

			return <Redirect to={{
				pathname: "/profile",
				state: { from: this.props.location }
			}}/>;
		} else {
			return <Redirect to={{
				pathname: "/login",
				state: {
					from: this.props.location,
					error: error
				}
			}}/>;
		}
	}
}

export default OAuth2RedirectHandler;
